import React, { useEffect, useState } from 'react';
import { WithStyles } from '@material-ui/core/styles';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { withStyles } from '@material-ui/core';
import Dashboard from '../../../../layouts/Dashboard';
import ViewLocationIntegrations from '../../../../components/Global/LocationIntegrations/View';
import { locationIntegrationsInitQuery } from './queries';
import styles from './styles';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>;
}

const LocViewIntegrations = ({ classes, history }: Props): React.ReactElement => {
  const [locationId, setLocationId] = useState<string>('');

  const { data } = useQuery(locationIntegrationsInitQuery, { fetchPolicy: 'no-cache' });

  useEffect(() => {
    if (data?.locations?.[0]) {
      setLocationId(data.locations[0].id);
    }
  }, [data]);

  const handleEdit = (step: number) => {
    history.push(`/loc/integrations/edit?step=${step}`);
  };

  if (!locationId) {
    return <Dashboard title="Integrations"><div /></Dashboard>;
  }

  return (
    <Dashboard title="Integrations">
      <ViewLocationIntegrations location_id={locationId} handleEdit={handleEdit} />
    </Dashboard>
  );
};

export default withRouter(withStyles(styles)(LocViewIntegrations));
